export default "__VITE_ASSET__BZOJ2aCs__"